export default __webpack_public_path__ + "static/media/fifteen.359f05f4.jpeg";